import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ColumnDef } from "shared-lib";
import { ClientDto } from "@merchant_api/models/client-dto";
import { CurrentUserPermissions } from "@merchant_app/shared/current-user-permissions";

@Component({
    selector: "app-client-log",
    templateUrl: "./client-log.component.html",
    styleUrls: ["./client-log.component.less"],
    standalone: false
})
export class ClientLogComponent {

    @Input() clients: ClientDto[];
    @Input() loading = false;
    @Input() error: Error;

    // NOTE: Optimise table widths against minimum table width (or table can have bottom horizontal scrollbar)
    clientColumnDefs: ColumnDef[] = [
        { id: "leftGutter", title: "", flexWidthBasisInPixels: 20, flexWidthGrow: 0},
        { id: "id", title: "ID", flexWidthBasisInPixels: 150, flexWidthGrow: 0, canSort: true},
        { id: "name", title: "Name", flexWidthBasisInPixels: 320, flexWidthGrow: 0, canSort: true},
        { id: "clientId", title: "Client ID", flexWidthBasisInPixels: 380, flexWidthGrow: 1, canSort: true},
        { id: "rightGutter", title: "", flexWidthBasisInPixels: 20, flexWidthGrow: 0},
    ];

    onClickCreate() {
        if (this.hasCreatePermission) {
            this.router.navigate([`/dashboard/developer/clients/create`]);
        }
    }

    onRowSelected(id: string) {
        if (this.hasGetPermission) {
            this.router.navigate([`/dashboard/developer/clients/${id}`]);
        }
    }

    constructor(private router: Router, private currPerms: CurrentUserPermissions) {}

    get hasCreatePermission(): boolean {
        return this.currPerms.has(["core.clients.create"]);
    }

    get hasGetPermission(): boolean {
        return this.currPerms.has(["core.clients.get", "core.roles.search"]);
    }

}
